export const setCookie = (key: string, value: string, domain: string, expires: number | string) => {
  let cookieStr = encodeURIComponent(key) + '=' + encodeURIComponent(value) + ';'

  if (expires) {
    if (typeof expires === 'number') {
      const dateExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24)
      cookieStr += 'expires=' + dateExpires.toUTCString() + ';'
    } else if (expires.includes('min')) {
      const dateExpires = new Date(new Date().getTime() + 1000 * 60)
      cookieStr += 'expires=' + dateExpires.toUTCString() + ';'
    }
  }
  if (domain) {
    cookieStr += 'domain=' + domain + ';'
  }
  document.cookie = cookieStr
}

export const setEssentialCookies = () => {
  const year = 365
  const cookie_consent = [
    'EssentialCookies',
    '{"consent":{"ad_storage":"granted","ad_user_data":"granted","ad_personalization":"denied","analytics_storage":"denied"}}',
  ]

  const domain = window.location.hostname === 'localhost' ? '' : '.career.io'
  setCookie('cookie_consent', JSON.stringify(cookie_consent), domain, year)
}

export const acceptAllCookies = () => {
  const year = 365
  const cookie_consent = [
    'EssentialCookies',
    'AnalyticalCookies',
    'TargetingCookies',
    '{"consent":{"ad_storage":"granted","ad_user_data":"granted","ad_personalization":"granted","analytics_storage":"granted"}}',
  ]

  const domain = window.location.hostname === 'localhost' ? '' : '.career.io'
  setCookie('cookie_consent', JSON.stringify(cookie_consent), domain, year)
}

export const getCookieConsent = (name: string) => {
  if (document.cookie.includes(name)) {
    name = encodeURIComponent(name)
    const regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g')
    const result: Array<string> | null = regexp.exec(document.cookie)
    return result && JSON.parse(decodeURIComponent(result[1]))
  } else {
    return undefined
  }
}
